import * as Preact from "preact"

import "./Huds.less"

export default function TriangleHud(stage) {
    if(stage == undefined) return
    if(stage.flags != undefined && stage?.flags["hud"] == "hidden") return
    return (
        <div class="TriangleHud"/>
    )
}
